"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOCK_CART_ITEM_CARBON_NEUTRAL_GAS = void 0;
const index_1 = require("../../generated-source/api/index");
const index_2 = require("../../constants/index");
const site_address_mock_1 = require("./site-address.mock");
exports.MOCK_CART_ITEM_CARBON_NEUTRAL_GAS = {
    sku: 'CBN_RESI_G',
    cartItemId: '3113',
    additionalData: {
        productCategory: index_1.ProductCategory.CarbonNeutral,
        parentCartItemId: '3111',
        productQualification: {
            customerType: 'residential',
            fuelType: index_1.FuelTypes.GAS,
            requestType: index_2.RequestType.SWITCH,
            siteAddress: site_address_mock_1.MOCK_SITE_ADDRESS,
            hasElectricityWorkSinceLastDisconnection: false,
            electricityLifeSupport: 'No',
        },
        productConfiguration: {
            connectionDate: '2020-09-09T00:00:00Z',
            offerId: '022',
            contractNumber: null,
        },
        productDisplayAttributes: {
            productName: 'Carbon Neutral certification (electricity)',
            bpidAvailable: true,
            referencePrice: '12%',
            estimatePrice: 1246,
            estimateInfo: 'annual estimate and VDO comparison for using 4000 kWh on a single rate tariff in the CitiPower network',
            infoDoc: '',
        },
    },
    productContent: {},
    productDiscounts: [],
};
//# sourceMappingURL=cart-item.carbon-neutral-gas.mock.js.map